import { NgModule } from "@angular/core";
import { AddQuestionsComponent } from './add-questions.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@fuse/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FusePipesModule } from 'app/core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BarRatingModule } from 'ngx-bar-rating';

@NgModule({
    declarations: [
        AddQuestionsComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        FusePipesModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        DatePickerModule,
        NgxMatSelectSearchModule,
        BarRatingModule
    ],
    entryComponents: [
        AddQuestionsComponent
    ],
    exports: [
        AddQuestionsComponent
    ]
})

export class AddQuestionsModule {

}